import * as z from "zod";
import type { SystemItem } from "./til-fields";

// A fact of the warehouse Nexxt cannot apply waits whole in the domain that consumes it, until the data is set right
// (I-11 §5): receipts in procurement (ADR-138), shipments and executions of movements in logistics (ADR-130,
// ADR-142). What their lists, counts and retries share is here, once; each domain keeps its table and its reasons.

/** Items of a fact that waits its list shows: a fact holds up to 5,000. */
export const WAITING_ITEMS_SHOWN = 50;

/** Facts applied again in one call: each is the whole work of its message, a few statements. */
export const MAX_RETRIED_FACTS = 25;

/**
 * Applies again the facts that wait, once the mapping, the SKU or the instruction is set right: each one applied goes,
 * the others wait with the reason of now.
 */
export const retryWaitingInput = z.object({ ids: z.array(z.uuid()).min(1).max(MAX_RETRIED_FACTS) });
export type RetryWaitingInput = z.input<typeof retryWaitingInput>;

/** How many were applied and how many still wait, under the name of the facts in the OpenAPI document. */
export const retryWaitingDto = (id: string) =>
  z.object({ applied: z.number().int(), waiting: z.number().int() }).meta({ id });

/**
 * The systems a fact of the warehouse comes from (I-11, ADR-144): its warehouse and items are in the codes of that
 * system, and a fact that waits says which, so a code is mapped for the system that sent it.
 */
export const waitingSources = ["ims", "gxo"] as const;
export type WaitingSource = (typeof waitingSources)[number];

/** The codes of an item the reason of a fact that waits is about, as the warehouse sent them. */
export const waitingItemCodes = {
  bcItemId: z.string().nullable(),
  skuCode: z.string().nullable(),
  ean: z.string().nullable(),
};

/** The codes of an item of a message, as a fact that waits keeps them. */
export const waitingCodesOf = (item: SystemItem) => ({
  bcItemId: item.bcItemId ?? null,
  skuCode: item.skuCode ?? null,
  ean: item.ean ?? null,
});
